<template>
  <div>
    <div>
      <lottie-animation
        :path="lottie.src"
        :loop="true"
        :autoPlay="true"
        :width="lottieWidth"
        :height="lottieHeight"
      />
    </div>
    <div>
      <h3>{{ callToAction }}</h3>
    </div>
    <div style="height: 100vh">
      <b-button
          class="text-center"
          variant="primary"
          @click.prevent="emitContinue">
        {{ button }}
      </b-button>
    </div>
  </div>
</template>

<script>
import FormButton from "./FormButton";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"; // import lottie-vuejs
export default {
  props: {
    callToAction: String,
    button: String,
    lottieWidth: {
      type: Number,
      default: 500
    },
    lottieHeight: {
      type: Number,
      default: 500
    },
    lottie: {
      type: Object,
      default() {
        return {
          src: "assets/lotties/blog-management.json",
          alt: "Standard"
        };
      }
    }
  },
  components: {
    FormButton,
    LottieAnimation
  },
  methods: {
    emitContinue() {
      this.$emit("continue");
    },
    setAnimController() {}
  },
  created() {
    window.addEventListener("keyup", this.emitContinue);
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.emitContinue);
  }
};
</script>

<style lang="scss" scoped>
.vue-form__splash1 {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 25px;

  &__cta {
    font-size: 2rem;
  }
}
</style>
